module.exports = __webpack_public_path__ + "fonts/CrimsonText-Regular.134c0157.ttf";